import type { ICookieConsent } from '@/utils/cookieConsent.utils';
import { getCookieConsentDomain } from '@/utils/cookieConsent.utils';
import { clearPendingCheckoutContext } from './checkoutStorage';

export const TRACKING_PARAM_STORAGE_KEY = 'digidoo_tracking_params';

/** Remove only optional tracking data; never touch application or login/session cookies. */
export function clearUnconsentedTrackingStorage(consent: ICookieConsent | null): void {
  try {
    const hostname = window.location.hostname;
    const domains = new Set(['', hostname, getCookieConsentDomain(hostname) ?? '']);
    for (const entry of document.cookie.split(';')) {
      const name = entry.trim().split('=')[0];
      if (!name) continue;
      const analyticsCookie = /^(_ga(?:_|$)|_gid$|_gat)/.test(name);
      const marketingCookie = /^(_fbp$|_fbc$|_gcl_|_gac_|_ttp$|_tt_enable_cookie$|ttcsid|ttclid$)/.test(name);
      if ((!consent?.analytics && analyticsCookie) || (!consent?.marketing && marketingCookie)) {
        for (const domain of domains) {
          document.cookie = `${name}=; Max-Age=0; Path=/${domain ? `; Domain=${domain}` : ''}; SameSite=Lax`;
        }
      }
    }
  } catch {
    // Browser storage restrictions must not break the app.
  }
  try {
    if (!consent?.marketing) window.localStorage.removeItem('_gcl_ls');
  } catch {
    // A denied storage API must not prevent cleaning up the others.
  }
  try {
    if (!consent?.analytics || !consent.marketing) window.sessionStorage.removeItem(TRACKING_PARAM_STORAGE_KEY);
  } catch {
    // Current URL parameters still let consented navigation continue without storage.
  }
  if (!consent?.analytics && !consent?.marketing) clearPendingCheckoutContext();
}
